// GEL BÊTA le 07/10/2026. Voir docs/GEL_BETA.md.
// Architecture figée : paiement dual, Coco via settings, rôles user_roles/has_role, âge 18 soft, pas de Connect.
// Porte ouverte : corrections de retours testeurs uniquement sur ordre Hiti, lot unique, sans rouvrir ces règles.
// Interdit sans Hiti : tama-wip→main, édition client.ts / types.ts / .env / config.toml / previewAuthStorage.
/** Part minimale de l'image qui doit rester visible pour accepter un recadrage. */
const MIN_VISIBLE_PART = 0.65;

export type VideoFit = "cover" | "contain";

/** Choisit le cadrage qui remplit la carte sans mutiler une image trop différente. */
export function resolveVideoFit(videoRatio: number, cardRatio: number): VideoFit {
  if (!(videoRatio > 0) || !(cardRatio > 0)) return "cover";

  const visiblePart = Math.min(videoRatio, cardRatio) / Math.max(videoRatio, cardRatio);
  return visiblePart >= MIN_VISIBLE_PART ? "cover" : "contain";
}

/** Applique le cadrage d'après les dimensions réelles du média et de sa carte. */
export function applyVideoFit(el: HTMLVideoElement) {
  const { videoWidth, videoHeight, clientWidth, clientHeight } = el;
  if (!videoWidth || !videoHeight || !clientWidth || !clientHeight) return;

  el.style.objectFit = resolveVideoFit(
    videoWidth / videoHeight,
    clientWidth / clientHeight,
  );
}

const fitObservers = new WeakMap<HTMLVideoElement, ResizeObserver>();

/** Maintient le cadrage pendant les changements de vidéo, taille et orientation. */
export function watchVideoFit(el: HTMLVideoElement) {
  if (fitObservers.has(el)) return;

  const updateFit = () => applyVideoFit(el);
  const observer = new ResizeObserver(updateFit);

  // Les dimensions de l'image arrivent tard (HLS, recyclage de carte) : on
  // réapplique à chaque signal, le premier timeupdate servant de filet.
  el.addEventListener("loadedmetadata", updateFit);
  el.addEventListener("loadeddata", updateFit);
  el.addEventListener("resize", updateFit);
  el.addEventListener("emptied", () => {
    el.addEventListener("timeupdate", updateFit, { once: true });
  });
  el.addEventListener("timeupdate", updateFit, { once: true });
  observer.observe(el);
  fitObservers.set(el, observer);
  applyVideoFit(el);
}
/** Même règle pour une image (création publicitaire). */
export function applyImageFit(img: HTMLImageElement) {
  const { naturalWidth, naturalHeight, clientWidth, clientHeight } = img;
  if (!naturalWidth || !naturalHeight || !clientWidth || !clientHeight) return;
  img.style.objectFit = resolveVideoFit(naturalWidth / naturalHeight, clientWidth / clientHeight);
}
